import { useQuery } from "@tanstack/react-query";
import { fetchPressCardStatus } from "../../../../api/pressCardApi";

/**
 * 어린이 기자단 기자증 상태 조회 훅
 *
 * - GET /api/members/press-card?userId={profile_id} (팝콘 백엔드)
 * - isPressCardValid: 발급 완료 + 유효기간 유효 (메뉴 문구/링크 분기 기준)
 *
 * @param userId 조회 대상 사용자 (MyContext user.id = profile_id, "TMPDS..." 형태)
 * @param enabled 로그인 상태일 때만 호출 (비로그인 시 호출 생략)
 */
export const usePressCardQuery = (
  userId: string | null,
  enabled: boolean = true
) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["pressCard", userId],
    queryFn: () => fetchPressCardStatus(userId),
    enabled: enabled && !!userId,
    staleTime: 0, // 캐싱 비활성화 - 항상 최신 발급 상태 조회
    gcTime: 0,
  });

  return {
    pressCard: data ?? null,
    isPressCardValid: !!data?.isValid,
    isLoading,
    error,
    refetchPressCard: refetch,
  };
};
